import { productsParamsToPostData } from './utils';
import { scConfigurationToPostData, } from '../../components/UI/product-selector/product-selector-utils';
import { fetchers, } from '@pes-ui/utils';
import { getSprykerBaseQueryParams } from '../utils/helpers';
export async function getMyProducts(host) {
  try {
    const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
    const response = await fetchers.getMyProducts({
      contextRoot,
      countryCode,
      languageCode,
    });
    if (response.lists.length === 0) {
      throw new Error('[FAVORITES] No favorites received');
    }
    return response.lists.map((productGroupShort) => (Object.assign(Object.assign({}, productGroupShort), { products: productGroupShort.products
        .map(Object.entries)
        .map(([[productId, quantity]]) => ({ productId, quantity })) })));
  }
  catch (error) {
    console.warn(error);
    return [];
  }
}
export function scAddToCart(host, configurationEvent) {
  const payload = scConfigurationToPostData(configurationEvent);
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.postMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    payload,
  });
}
export function addToMyProducts(host, productsParams) {
  const payload = productsParamsToPostData(productsParams);
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.postMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    payload,
  });
}
export function deleteMyProducts(host, productsParams) {
  const { repositoryId, id } = productsParams;
  const idToDelete = repositoryId || (Array.isArray(id) ? id[0] : id);
  const params = { id: idToDelete };
  const { countryCode, languageCode, contextRoot } = getSprykerBaseQueryParams(host);
  return fetchers.deleteMyProducts({
    contextRoot,
    countryCode,
    languageCode,
    params,
  });
}
